import { render, staticRenderFns } from "./Fragment.vue?vue&type=template&id=1a099cbb&scoped=true&"
import script from "./Fragment.vue?vue&type=script&lang=js&"
export * from "./Fragment.vue?vue&type=script&lang=js&"
import style0 from "./Fragment.vue?vue&type=style&index=0&id=1a099cbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a099cbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
